export const buildUnifiedSearchPath = (query) => `/search?q=${encodeURIComponent(query.trim())}`;
